<template>
<div class="chapter">
<div class="inner_page">
<div id="d3ce853440f00-d1e333"><span id="page1">
<h2 class="part-number">PART ONE</h2>
<h2 class="part-title">Fry’s Bay, Florida, 1974</h2></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780107394_epub_part001.vue?ede4ff9e